export default {
    prescription: state => state.prescription,
    selectedDrug: state => state.selectedDrug,
    edition: state => state.edition,
    files: state => state.files,
    shareDate: state => state.shareDate,
    clinicalHandouts: state => state.clinicalHandouts,
    prescriptionId: state => state.prescriptionId,
    prescriptionRevision: state => state.revision,
    patientId: state => state.patientId,
    encounterId: state => state.encounterId,
    contextPrescriptions: state => state.contextPrescriptions,
    nextCursor: state => state.nextCursor,
    hasMore: state => state.hasMore,
    contextSelectionRequired: state => state.contextSelectionRequired,
    prescriptionReadonly: state => state.readonly,
    prescriptionInitialized: state => state.initialized,
    professionalSnapshot: state => state.professionalSnapshot,
}
